import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { LandingPageTestimonials, TestimonialCard } from './style';
import BackArrow from 'assets/icon/back-arrow.svg';

interface Testimonial {
  id: number;
  name: string;
  date: string;
  rating: number;
  content: string;
  avatar?: string;
}

const testimonials: Testimonial[] = [
  {
    id: 1,
    name: "Flávia Larissa de Oliveira Cristo",
    date: "",
    rating: 5,
    content: "Amei a forma como o assunto foi abordado. O curso é excelente!"
  },
  {
    id: 2,
    name: "Inacia Maria da Silva Canales",
    date: "",
    rating: 5,
    content: "Amei ❤️ Obrigada por compartilhar tantas informações, para as mamães de primeira viagem é imprescindível. Agora me sinto mais segura! 🥰"
  },
  {
    id: 3,
    name: "Kalline Carvalho Huebner",
    date: "",
    rating: 5,
    content: "Essas aulas são maravilhosas! São tantas dicas importantes!"
  },
  {
    id: 4,
    name: "Gabriela Silva Rodrigues Ferruz",
    date: "",
    rating: 5,
    content: "Obrigada por nos fornecer aulas tão boas e sem custo algum pra nós, mamães de primeira viagem agradecem! ☺️"
  },
  {
    id: 5,
    name: "Aracelly de Oliveira Alves",
    date: "",
    rating: 5,
    content: "Nossa! Quanta informação, vou voltar aqui várias vezes...rs"
  }
];


  const TestimonialsSection: React.FC = () => {
  const [currentSlide, setCurrentSlide] = useState<number>(0);
  const [itemsPerSlide, setItemsPerSlide] = useState<number>(2);
  const history = useHistory();

  // Atualiza itemsPerSlide baseado na largura da tela
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) setItemsPerSlide(1);
      else setItemsPerSlide(3); // agora desktop = 3 slides
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);


  const totalSlides = Math.ceil(testimonials.length / itemsPerSlide);

  // Auto-slide
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % totalSlides);
    }, 5000);
    return () => clearInterval(interval);
  }, [totalSlides]);

  const handlePrevSlide = () => {
    setCurrentSlide((prev) => (prev === 0 ? totalSlides - 1 : prev - 1));
  };

  const handleNextSlide = () => {
    setCurrentSlide((prev) => (prev === totalSlides - 1 ? 0 : prev + 1));
  };

  const goToSlide = (index: number) => {
    setCurrentSlide(index);
  };

  const renderStars = (rating: number) => {
    return Array.from({ length: 5 }, (_, index) => (
      <span key={index} className={index < rating ? 'star filled' : 'star'}>
        ★
      </span>
    ));
  };

  return (
    <LandingPageTestimonials itemsPerSlide={itemsPerSlide}>
      <div className="container-content">
        <div className="testimonials-header">
          <h2>Aprovado por elas</h2>
          <p>O que dizem as mulheres que se prepararam com a gente</p>
        </div>

        <div className="testimonials-carousel">
          <div className="carousel-container">
            <div
              className="testimonials-grid"
              style={{ transform: `translateX(-${currentSlide * 100}%)` }}
            >
              {Array.from({ length: totalSlides }).map((_, slideIndex) => (
                <div key={slideIndex} className="testimonials-slide">
                  {testimonials
                    .slice(slideIndex * itemsPerSlide, (slideIndex + 1) * itemsPerSlide)
                    .map((testimonial) => (
                      <TestimonialCard key={testimonial.id}>
                        <div className="testimonial-content">
                          <div className="quote-icon">
                            <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <rect width="44" height="44" rx="10" fill="#FFEAF6"/>
                              <path d="M26.5 32.5L25.5625 32.5C25.4753 32.5 25.4004 32.4794 25.3281 32.4287L25.2568 32.3682C25.1617 32.2729 25.125 32.1788 25.125 32.0625L25.125 30.1875C25.125 30.1002 25.1457 30.0252 25.1963 29.9531L25.2568 29.8818C25.3523 29.7864 25.4463 29.75 25.5625 29.75L26.5 29.75C27.6678 29.75 28.6788 29.3308 29.5049 28.5049C30.331 27.6787 30.75 26.6679 30.75 25.5L30.75 25.0312C30.75 24.5093 30.5613 24.0498 30.1934 23.6816C29.825 23.3133 29.3654 23.125 28.8438 23.125L25.5625 23.125C24.9124 23.125 24.3757 22.903 23.9238 22.4512C23.4715 21.9988 23.25 21.4627 23.25 20.8125L23.25 15.1875C23.25 14.5371 23.4718 14.0011 23.9238 13.5488C24.376 13.0969 24.9125 12.875 25.5625 12.875L31.1875 12.875C31.8376 12.875 32.3741 13.0969 32.8262 13.5488C33.2782 14.0011 33.5 14.537 33.5 15.1875L33.5 25.5C33.5 26.4487 33.3158 27.3511 32.9473 28.2109C32.6218 28.9703 32.1983 29.6351 31.6777 30.209L31.4492 30.4492C30.8227 31.0757 30.0784 31.5754 29.2109 31.9473C28.3508 32.3157 27.4487 32.5 26.5 32.5Z" stroke="#EBA1C6"/>
                              <path d="M13.3737 32.5L12.4371 32.5C12.3498 32.5 12.2749 32.4792 12.2028 32.4287L12.1315 32.3682C12.036 32.2726 11.9997 32.1785 11.9996 32.0625L11.9996 30.1875C11.9996 30.0716 12.0359 29.9775 12.1315 29.8818C12.2267 29.7867 12.3207 29.75 12.4371 29.75L13.3737 29.75C14.542 29.75 15.5536 29.3309 16.3795 28.5049C17.2052 27.6788 17.6246 26.6679 17.6246 25.5L17.6246 25.0312C17.6246 24.5748 17.4798 24.1661 17.1969 23.8242L17.068 23.6816C16.6999 23.313 16.2396 23.1251 15.7184 23.125L12.4371 23.125C11.8682 23.125 11.3866 22.9545 10.9723 22.6094L10.7985 22.4512C10.3465 21.9989 10.1246 21.463 10.1246 20.8125L10.1246 15.1875C10.1247 14.5369 10.3464 14.0009 10.7985 13.5488C11.2503 13.097 11.7869 12.875 12.4371 12.875L18.0621 12.875C18.7124 12.875 19.2489 13.0969 19.7008 13.5488C20.1527 14.0011 20.3746 14.5372 20.3746 15.1875L20.3746 25.5C20.3746 26.4486 20.1904 27.351 19.8219 28.2109C19.4503 29.0785 18.9504 29.823 18.3239 30.4492C17.7756 30.9975 17.137 31.4484 16.4049 31.8018L16.0856 31.9473C15.2252 32.3157 14.3229 32.5 13.3737 32.5Z" stroke="#EBA1C6"/>
                              </svg>
                          </div>

                          {/* <div className="rating">{renderStars(testimonial.rating)}</div> */}
                          <p className="testimonial-text">{testimonial.content}</p>

                          <div className="testimonial-author">
                            <div className="avatar">
                              <div className="avatar-placeholder">
                                <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <circle cx="22" cy="22" r="22" fill="#EBA1C6"/>
                                <path d="M22 18.7923C22 18.7923 23.3145 13.9998 27.4772 13.9998C30.7197 13.9998 33 16.7474 33 20.0026C33 24.5044 28.4966 27.4854 22 33.1699C15.5034 27.4854 11 24.5044 11 20.0026C11 16.7474 13.2803 13.9998 16.5228 13.9998C20.6855 13.9998 22 18.7923 22 18.7923Z" fill="white"/>
                                </svg>
                              </div>
                            </div>
                            <div className="author-info">
                              <h4>{testimonial.name}</h4>
                              <span>{testimonial.date}</span>
                            </div>
                          </div>
                        </div>
                      </TestimonialCard>
                    ))}
                </div>
              ))}
            </div>
          </div>

          <div className="carousel-controls">
            <button className="carousel-arrow prev" onClick={handlePrevSlide} aria-label="Depoimento anterior">
              <img src={BackArrow} alt="anterior" />
            </button>

            <div className="carousel-dots">
              {Array.from({ length: totalSlides }).map((_, index) => (
                <button
                  key={index}
                  className={`dot ${currentSlide === index ? 'active' : ''}`}
                  onClick={() => goToSlide(index)}
                  aria-label={`Ir para slide ${index + 1}`}
                />
              ))}
            </div>

            <button className="carousel-arrow next" onClick={handleNextSlide} aria-label="Próximo depoimento">
              <img src={BackArrow} alt="próximo" />
            </button>
          </div>
        </div>

        <div className="cta-section">
          <button className="cta-button" onClick={() => history.push('/signup')}>Inscreva-se Agora</button>
          <span className="cta-subtitle">100% online e gratuito</span>
        </div>
      </div>
    </LandingPageTestimonials>
  );
};

export default TestimonialsSection;
